export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./password-login.vue?vue&type=template&id=573a63c4"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/login/password-login.vue?vue&type=template&id=573a63c4
// module id = DJfH
// module chunks = 0